import { LandingNavbar } from "../components/Homepage/landing-navbar"
import SubscriberNews from "../components/SubscriberNews"

const SubscriberNewsPage = () => {
    return (
    <main className="h-full bg-[#111827] overflow-auto">
        <div className="mx-auto max-w-screen-xl h-full w-full">
            <LandingNavbar />
            <SubscriberNews />
        </div>
      </main>
    )
}

export default SubscriberNewsPage